import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'
import { getAuthState } from '../services/redux/auth/auth-selectors'
import { RouteConstants } from './navigation-types'
import { UserRole } from '../services/api/sharedTypes/User'

export const ProtectedRoutes: React.FC<{ children: JSX.Element, userRoutes?: RouteConstants[] }> = ({ children, userRoutes }) => {
    const { isAuthenticated, role } = useSelector(getAuthState)
    const location = useLocation()

    const hasAccessToRoute = userRoutes && userRoutes.includes(location.pathname as RouteConstants);

    if (!isAuthenticated || !role) {
        return <Navigate to={{ pathname: RouteConstants.unauthenticated }} replace={true} />
    }

    if (role !== UserRole.Admin && (!hasAccessToRoute || !userRoutes)) {
        return <Navigate to={{ pathname: RouteConstants.accessDenied }} replace={true} />
    }

    return children
}

export default ProtectedRoutes
